import {CommonModule, formatDate} from '@angular/common';
import {Component, DEFAULT_CURRENCY_CODE, Inject, Input, LOCALE_ID} from '@angular/core';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {MatLegacyTableDataSource as MatTableDataSource} from '@angular/material/legacy-table';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {Store} from '@ngrx/store';
import {BehaviorSubject} from 'rxjs';
import {filter, map, switchMap, take, tap} from 'rxjs/operators';
import {MaterialToSupplierDataService} from '../../../dave-data-module/services/material-to-supplier-data.service';
import {State} from '../../../dave-data-module/State';
import {getMaterialAmountByMaterialId} from '../../../dave-data-module/State/selectors/material-amount.selectors';
import {DaveListCardModule} from '../../../dave-list-card/dave-list-card.module';
import {AppButtonModule} from '../../../dave-utils-module/app-button-module/app-button.module';
import {isNotNullOrUndefined} from '../../../helper/helper';
import {CustomLabelService} from '../../../services/custom-label/custom-label.service';
import {MaterialAmountActionTypes} from '../../../dave-data-module/State/actions/material-amount.actions';
import {MaterialAmountType} from '@dave/types';
import {MaterialAmountEntity} from '../../../dave-data-module/entities/material-amount.entity';


interface MaterialToSupplierTableData {
    WarehouseMovementId: number;
    Date: string;
    Type: string;
    Amount: string;
    amount_as_float: number;
    createdAtForSort: number;
}
@Component({
    selector: 'app-material-to-amount-list-card[materialId]',
    standalone: true,
    imports: [CommonModule, AppButtonModule, DaveListCardModule, FontAwesomeModule],
    templateUrl: './material-to-amount-list-card.component.html',
    styleUrls: ['./material-to-amount-list-card.component.scss'],
})
export class MaterialToAmountListCardComponent {
    protected MaterialId$ = new BehaviorSubject<number>(null);

    @Input() set materialId(id: number) {
        if (this.MaterialId$.value !== id) {
            this.MaterialId$.next(id);
        }
    }

    public MaterialToMaterialTableDataLoading$ = new BehaviorSubject(false);
    public MaterialToMaterialTableData$ = this.MaterialId$.pipe(
        filter(isNotNullOrUndefined),
        tap(() => this.MaterialToMaterialTableDataLoading$.next(true)),
        switchMap((mId) =>
            this.store.select(getMaterialAmountByMaterialId({id: mId})).pipe(
                tap(() => this.MaterialToMaterialTableDataLoading$.next(false)),
                map(materials => {
                    console.log('selector triggered', materials);
                        if (!materials.length) {
                            return new MatTableDataSource<MaterialToSupplierTableData>([]);
                        }
                        return new MatTableDataSource<MaterialToSupplierTableData>(
                            materials.map(m => ({
                                WarehouseMovementId: m.WarehouseMovementId,
                                Date: formatDate(m.CreatedAt, 'shortDate', this.locale),
                                Amount: m.Amount.toString(),
                                Type: m.Type == MaterialAmountType.MaterialAmountTypeInit ? '-' : (m.Type == MaterialAmountType.MaterialAmountTypeInput ? 'Eingang': 'Ausgang'),
                                amount_as_float: m.Amount,
                                createdAtForSort: m.CreatedAt.getTime()
                            })),
                        );
                    }),
                    tap(
                        (dataSource) =>
                            (dataSource.sortingDataAccessor = (object, key) => {
                                switch (key) {
                                    case 'Date':
                                        return object.createdAtForSort;
                                    case 'Amount':
                                        return object.amount_as_float;
                                    default:
                                        return object[key].trim().toLowerCase();
                                }
                            }),
                    ),
                ),
            ),
        );

    constructor(
        private store: Store<State>,
        private materialToSupplierDataService: MaterialToSupplierDataService,
        private dialog: MatDialog,
        protected cls: CustomLabelService,
        @Inject(LOCALE_ID) private locale: string,
        @Inject(DEFAULT_CURRENCY_CODE) private defaultCurrencyCode: string,
    ) {
        this.MaterialId$.pipe(filter(isNotNullOrUndefined), take(1)).subscribe((id) => {
            this.store.dispatch(MaterialAmountActionTypes.Load({
                Payload: {
                    MaterialId: id.toString()
                }
            }));
        });

    }

    onAddWarehouseMovement() {
        console.log('onAddWarehouseMovement');
    }

    onOpenWarehouseMovement(movementId: number) {
        console.log('onOpenWarehouseMovement', movementId);
    }
}
